import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CustomFieldGroupsActions } from './custom-field-groups.actions';
import { CustomFieldService } from '../../services/custom-field.service';

@Injectable()
export class CustomFieldGroupsEffects {
  private actions$ = inject(Actions);
  private svc = inject(CustomFieldService);

  loadGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldGroupsActions.loadGroups),
      mergeMap(({ entityType }) =>
        this.svc.getGroups(entityType).pipe(
          map(groups => CustomFieldGroupsActions.loadGroupsSuccess({ groups })),
          catchError(err => of(CustomFieldGroupsActions.loadGroupsFailure({ error: err.message })))
        )
      )
    )
  );

  createGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldGroupsActions.createGroup),
      mergeMap(({ dto }) =>
        this.svc.createGroup(dto).pipe(
          map(group => CustomFieldGroupsActions.createGroupSuccess({ group })),
          catchError(err => of(CustomFieldGroupsActions.createGroupFailure({ error: err.message })))
        )
      )
    )
  );

  updateGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldGroupsActions.updateGroup),
      mergeMap(({ id, dto }) =>
        this.svc.updateGroup(id, dto).pipe(
          map(group => CustomFieldGroupsActions.updateGroupSuccess({ group })),
          catchError(err => of(CustomFieldGroupsActions.updateGroupFailure({ error: err.message })))
        )
      )
    )
  );

  deleteGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldGroupsActions.deleteGroup),
      mergeMap(({ id }) =>
        this.svc.deleteGroup(id).pipe(
          map(() => CustomFieldGroupsActions.deleteGroupSuccess({ id })),
          catchError(err => of(CustomFieldGroupsActions.deleteGroupFailure({ error: err.message })))
        )
      )
    )
  );
}
